<template>
  <v-row class="mt-4">
    <!-- Bank Cards -->
    <v-col cols="12" lg="4" v-for="(bank, index) in banks" :key="`bank-${bank.id}`">
      <v-card class="elevation-0 rounded-0 transition-method-card " :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
       <div class="three-dot-menu">
          <v-menu bottom left>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="confirmDeleteBank(bank.id)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-card-actions class="paymentImage align-center justify-center  " >
          <v-img max-height="45" max-width="178" src="/bank.png" alt="Bank"></v-img>
        </v-card-actions>
       
        <v-card-actions class="content">
          <div class="value">
            <span>Bank Name</span>
            <span>{{ bank.bank_name }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="value">
            <span>Account No.</span>
            <span>{{ bank.bank_acc_num }}</span>
          </div>
        </v-card-actions>

       <v-card-actions class="button-details">
          <v-dialog
            v-model="dialogVisibility[index]"
            transition="scale-transition"
            origin="center center"
            max-width="695"
            content-class="deposit-withdraw-popup bank-transfer-details-popup"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                tile
                outlined
                elevation="0"
                class="text-capitalize btn-account"
                color="greenMain"
                v-bind="attrs"
                v-on="on"
              >Details</v-btn>
            </template>
            <template v-slot:default="{ dialog }">
              <v-card
                class="rounded-0"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
              >
                <v-btn class="close" icon @click="dialogVisibility[index] = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="rounded-0">Bank Transfer Detail</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Brokers Bank Name</span>
                      <p class="text-left">{{ bank.bank_name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Bank Country</span>
                      <p class="text-sm-right text-left">{{ bank.bankcountries?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Account Name</span>
                      <p class="text-left">{{ bank.bank_acc_name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">City</span>
                      <p class="text-sm-right text-left">{{ bank.bankcities?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Account Number</span>
                      <p class="text-left">{{ bank.bank_acc_num }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">State / Province / Division</span>
                      <p class="text-sm-right text-left">{{ bank.bankstates?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Bank Swift Code</span>
                      <p class="text-left">{{ bank.bank_swift_num }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Postal Code</span>
                      <p class="text-sm-right text-left">{{ bank.bank_postal_code }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Bank IBAN Number</span>
                      <p class="text-left">{{ bank.bank_iban_num }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Bank Address</span>
                      <p class="text-sm-right text-left">{{ bank.bank_address }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- Crypto Cards -->
    <v-col cols="12" lg="4" v-for="address in cryptoaddresses" :key="`crypto-${address.id}`">
      <v-card class="elevation-0 rounded-0 transition-method-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
      <div class="three-dot-menu">
          <v-menu bottom left>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="confirmDeleteCrypto(address.id)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-card-actions class="paymentImage align-center justify-center">
          <v-img max-height="45" max-width="178" src="/crypto.png" alt="Crypto"></v-img>
        </v-card-actions>
        <v-card-actions class="content">
          <div class="value">
            <span>Currency</span>
            <span>{{ address.network }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="value">
            <span>Address</span>
            <span class="flexbox">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                @click="copyToClipboard(address.address)"
                style="cursor: pointer"
              >
                <g clip-path="url(#clip0_3711_11482)">
                  <path
                    d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                    stroke="#039de9"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.33203 9.9987H2.66536C2.31174 9.9987 1.9726 9.85822 1.72256 9.60817C1.47251 9.35813 1.33203 9.01899 1.33203 8.66536V2.66536C1.33203 2.31174 1.47251 1.9726 1.72256 1.72256C1.9726 1.47251 2.31174 1.33203 2.66536 1.33203H8.66536C9.01899 1.33203 9.35813 1.47251 9.60817 1.72256C9.85822 1.9726 9.9987 2.31174 9.9987 2.66536V3.33203"
                    stroke="#039de9"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3711_11482">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <strong>{{ getTruncatedAddress(address.address) }}</strong>
            </span>
          </div>

          <v-dialog
            v-model="dialogVisibility[index]"
            transition="scale-transition"
            origin="center center"
            max-width="695"
            content-class="deposit-withdraw-popup bank-transfer-details-popup"
          >
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn tile outlined elevation="0" class="text-capitalize btn-account" color="greenMain" v-bind="attrs" v-on="on">
                Details
              </v-btn>
            </template> -->
          </v-dialog>
        </v-card-actions>

        

        <v-card-actions class="button-details">
          <v-dialog
            v-model="dialogVisibility[`crypto-${address.id}`]"
            transition="scale-transition"
            origin="center center"
            max-width="695"
            content-class="deposit-withdraw-popup bank-transfer-details-popup"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                tile
                outlined
                elevation="0"
                class="text-capitalize btn-account"
                color="greenMain"
                v-bind="attrs"
                v-on="on"
                @click="getDetails(address.id)"
              >
                Details
              </v-btn>
            </template>
            <template v-slot:default="{ dialog }">
              <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <v-btn class="close" icon @click="handleClose(address)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="rounded-0">Crypto Transfer Detail</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Crypto Network</span>
                      <p class="text-left">{{ cryptodetails.network }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Crypto Address</span>
                      <p class="text-sm-right text-left">{{ cryptodetails.address }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { BANK__ACTIONS, CRYPTO__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "AllAccountsTab",

  data() {
    return {
      dialogVisibility: {},
    };
  },

  computed: {
    ...mapState("bank", ["banks"]),
    ...mapState("crypto", ["cryptoaddresses", "cryptodetails"]),
  },

  methods: {
    ...mapActions("bank", [BANK__ACTIONS.GETALL, BANK__ACTIONS.DELETEBANK]),
    ...mapActions("crypto", [CRYPTO__ACTIONS.GETALL, CRYPTO__ACTIONS.DETAILS, CRYPTO__ACTIONS.DELETECRYPTO]),

    handleClose(item) {
      this.$set(this.dialogVisibility, `crypto-${item?.id}`, false);
    },

    updateBank(bank) {
      this.$router.push({ path: '/update-bank', query: { id: bank.id } });
    },
    //delete cryto address
    confirmDeleteCrypto(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to delete this crypto?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",   
        cancelButtonColor: "#3085d6",
        customClass: {
          cancelButton: "swal-cancel-btn",
          confirmButton: "swal-confirm-btn",
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteCryptoNow(id);
        }
      });
    },
     async deleteCryptoNow(id) {
      try {
        await this[CRYPTO__ACTIONS.DELETECRYPTO](id);
        Swal.fire("Deleted!", "Crypto address deleted successfully.", "success");
      } catch (error) {
        Swal.fire("Error", "Failed to delete Crypto.", "error");
      }
    },
    //Delete bank address
    confirmDeleteBank(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to delete this bank?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",   
        cancelButtonColor: "#3085d6",
        customClass: {
          cancelButton: "swal-cancel-btn",
          confirmButton: "swal-confirm-btn",
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteBankNow(id);
        }
      });
    },
     async deleteBankNow(id) {
      try {
        await this[BANK__ACTIONS.DELETEBANK](id);
        Swal.fire("Deleted!", "Bank deleted successfully.", "success");
        // this[BANK__ACTIONS.GETALL]();
      } catch (error) {
        Swal.fire("Error", "Failed to delete bank.", "error");
      }
    },

    getTruncatedAddress(address) {
      if (!address) return '';
      const start = address.slice(0, 7);
      return address.length > 10 ? `${start}...` : address;
    },

    copyToClipboard(address) {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          alert("Address copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    },

    async getDetails(id) {
      try {
        await this[CRYPTO__ACTIONS.DETAILS](id);
      } catch (error) {
        console.error("Error fetching details:", error);
      }
    },

    initializeDialogVisibility() {
      // Initialize for bank cards
      this.banks.forEach((bank) => {
        this.$set(this.dialogVisibility, `bank-${bank.id}`, false);
      });
      // Initialize for crypto cards
      this.cryptoaddresses.forEach((crypto) => {
        this.$set(this.dialogVisibility, `crypto-${crypto.id}`, false);
      });
    },
  },

  async mounted() {
    await Promise.all([
      this[BANK__ACTIONS.GETALL](),
      this[CRYPTO__ACTIONS.GETALL]()
    ]);
    this.initializeDialogVisibility();
    console.log("Bank Details", this.banks);
  },

  watch: {
    banks: {
      handler() {
        this.initializeDialogVisibility();
      },
      immediate: true,
    },
    cryptoaddresses: {
      handler() {
        this.initializeDialogVisibility();
      },
      immediate: true,
    },
  },
};
</script>
<style>
.three-dot-menu {
  position: absolute;
  right: 2px;
  top: 5px;
  z-index: 5;
}
.swal-cancel-btn {
  color: #ffffff !important;  
}
.swal-confirm-btn {
  color: #ffffff !important; 
}

</style>